import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["clsPrefix", "children", "transitionName", "placement", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "trigger", "getDocument", "disabled", "delay", "delayShow", "delayHide"];

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-dropdown.
* homepage: https://github.com/react-component/dropdown
*/
import React from 'react';
import ReactDOM from 'react-dom';
import Trigger from 'rc-trigger';
import placements from './placement';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  animation: PropTypes.any,
  // 暂不抛出使用， 将动画名称前添加 clsPrefix- 前缀
  align: PropTypes.object,
  // 暂不抛出使用， 由placement 接受 转换使用
  children: PropTypes.element,
  clsPrefix: PropTypes.string,
  disabled: PropTypes.bool,
  hideAction: PropTypes.array,
  getPopupContainer: PropTypes.func,
  minOverlayWidthMatchTrigger: PropTypes.bool,
  overlayClassName: PropTypes.string,
  overlayStyle: PropTypes.object,
  overlay: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onVisibleChange: PropTypes.func,
  placement: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showAction: PropTypes.array,
  transitionName: PropTypes.string,
  // 动画名称，目前支持slide-up 可自定义enter appear leave动画
  trigger: PropTypes.array,
  visible: PropTypes.bool
};
var defaultProps = {
  children: /*#__PURE__*/React.createElement("span", null),
  disabled: false,
  trigger: ['hover'],
  // 触发的事件数组 click/hover/focus
  showAction: [],
  // 显示时的钩子函数数组 click/mouseEnter/focus
  hideAction: [],
  // 隐藏时的钩子函数数组 click/mouseLeave/blur
  minOverlayWidthMatchTrigger: true,
  overlayClassName: '',
  overlayStyle: {},
  overlay: '暂无数据',
  placement: 'bottomLeft',
  defaultVisible: false
};

var jadgeState = function jadgeState(props) {
  if ('visible' in props) {
    return props.visible;
  }

  return props.defaultVisible;
};

var Dropdown = (_dec = WebUI({
  name: "dropdown",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);
    _this.state = {
      visible: jadgeState(_this.props)
    };
    _this.triggerRef = null;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onVisibleChange = _this.onVisibleChange.bind(_assertThisInitialized(_this));
    _this.getMenuElement = _this.getMenuElement.bind(_assertThisInitialized(_this));
    _this.getPopupDomNode = _this.getPopupDomNode.bind(_assertThisInitialized(_this));
    _this.afterVisibleChange = _this.afterVisibleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Dropdown, [{
    key: "onClick",
    value: function onClick(e) {
      var props = this.props;
      var overlayProps = props.overlay.props; // do no call onVisibleChange, if you need click to hide, use onClick and control visible

      if (!('visible' in props)) {
        this.setState({
          visible: false
        });
      }

      if (overlayProps.onClick) {
        overlayProps.onClick(e);
      }
    }
  }, {
    key: "onVisibleChange",
    value: function onVisibleChange(visible) {
      var props = this.props;

      if (!('visible' in props)) {
        this.setState({
          visible: visible
        });
      }

      props.onVisibleChange && props.onVisibleChange(visible);
    }
  }, {
    key: "getMenuElement",
    value: function getMenuElement() {
      var _this$props = this.props,
          overlay = _this$props.overlay,
          clsPrefix = _this$props.clsPrefix;
      var overlayNode = typeof overlay === 'function' ? overlay() : overlay;
      overlayNode = React.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/React.createElement("span", null, overlayNode) : overlayNode);
      return /*#__PURE__*/React.cloneElement(overlayNode, {
        prefixCls: "".concat(clsPrefix, "-menu"),
        onClick: this.onClick
      });
    }
  }, {
    key: "getPopupDomNode",
    value: function getPopupDomNode() {
      return this.triggerRef.getPopupDomNode();
    }
  }, {
    key: "afterVisibleChange",
    value: function afterVisibleChange(visible) {
      if (visible && this.props.minOverlayWidthMatchTrigger) {
        var overlayNode = this.getPopupDomNode();
        var rootNode = ReactDOM.findDOMNode(this);

        if (rootNode.offsetWidth > overlayNode.offsetWidth) {
          overlayNode.style['min-width'] = "".concat(rootNode.offsetWidth, "px");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          clsPrefix = _this$props2.clsPrefix,
          children = _this$props2.children,
          transitionName = _this$props2.transitionName,
          placement = _this$props2.placement,
          getPopupContainer = _this$props2.getPopupContainer,
          showAction = _this$props2.showAction,
          hideAction = _this$props2.hideAction,
          overlayClassName = _this$props2.overlayClassName,
          overlayStyle = _this$props2.overlayStyle,
          trigger = _this$props2.trigger,
          getDocument = _this$props2.getDocument,
          disabled = _this$props2.disabled,
          delay = _this$props2.delay,
          delayShow = _this$props2.delayShow,
          delayHide = _this$props2.delayHide,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var popupAlign = _typeof(placement) === 'object' ? placement : {};
      var popupPlacement = typeof placement === 'string' ? placement : "";
      return /*#__PURE__*/React.createElement(Trigger, _extends({}, props, {
        prefixCls: clsPrefix,
        ref: function ref(_ref) {
          return _this2.triggerRef = _ref;
        },
        popupClassName: overlayClassName,
        popupStyle: overlayStyle,
        builtinPlacements: placements,
        action: trigger,
        showAction: showAction,
        hideAction: hideAction,
        popupPlacement: popupPlacement,
        popupAlign: popupAlign,
        popupTransitionName: transitionName // popupAnimation={animation} // 取消使用animation 全部使用transitionName
        ,
        popupVisible: disabled ? false : this.state.visible,
        afterPopupVisibleChange: this.afterVisibleChange,
        popup: this.getMenuElement(),
        onPopupVisibleChange: this.onVisibleChange,
        getPopupContainer: getPopupContainer,
        getDocument: getDocument,
        mouseEnterDelay: delayShow && delayShow / 1000 || delay && delay / 1000,
        mouseLeaveDelay: delayHide && delayHide / 1000 || delay && delay / 1000
      }), children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.visible !== undefined && props.visible !== state.visible) {
        return _objectSpread(_objectSpread({}, state), {}, {
          visible: props.visible
        });
      }

      return null;
    }
  }]);

  return Dropdown;
}(React.Component)) || _class);
;
Dropdown.propTypes = propTypes;
export default Dropdown;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-dropdown/src/Dropdown.js